import { z } from 'zod'

export const SearchSchema = z.object({
    parentId: z.number().optional(),
    status: z.number().max(1).optional(),
    page: z.number().default(1),
    size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
